import { compareAsc } from 'date-fns';
import { ChildEventProps } from '../../../../types';

export const eventIsAvailable = (event: ChildEventProps) =>
    ('is_sold_out' in event && !event.is_sold_out) || !('is_sold_out' in event);

export const findNextAvailableEvent = (
    event: any,
    childEvents: ChildEventProps[],
) => {
    const availableChildEvents = childEvents.filter(eventIsAvailable);
    // If there is not a future available event, will return the event itself
    const initialDate = new Date(event.start.local);
    const firstAvailableEvent = availableChildEvents.find(
        (event: ChildEventProps) =>
            compareAsc(new Date(event.start.local), initialDate) > 0,
    );
    return (
        firstAvailableEvent ??
        availableChildEvents[availableChildEvents.length - 1]
    );
};

export const findFirstAvailableEvent = (
    childEvents: ChildEventProps[] | null,
) => {
    if (!childEvents) return null;
    const availableEvents: ChildEventProps[] = childEvents.filter((event) =>
        eventIsAvailable(event),
    );
    return availableEvents[0] ?? null;
};
export const findEventOnAvailableEvents = (
    event: any,
    childEvents: ChildEventProps[],
) => {
    return childEvents.find(
        (item) => item.id === event.id && eventIsAvailable(item),
    );
};

export const shouldShowMoreOptions = (childEvents: ChildEventProps[]) =>
    childEvents.length > 5;
